import { useState } from 'react'
import { useRouter } from 'next/router'
import StakingClaimDialog from './StakingClaimDialog'
import StakingTable from './StakingTable'
import { notify } from '../../utils/notifications'
import {
  stakingProgramClaim,
  stakingProgramDeposit,
  stakingProgramWithdraw,
} from '../../utils/client/auth/staking-deposit-api'
import StakingDepositDialog from './StakingDepositDialog'
import StakingWithdrawDialog from './StakingWithdrawDialog'
import StakingScheduleDialog from './StakingScheduleDialog'

const StakingContent = ({ stakingPrograms, myStakingPrograms, type, accessToken, isLogin, refresh }) => {
  const [selectClaimItem, setSelectClaimItem] = useState(undefined)
  const [selectStakingItem, setSelectStakingItem] = useState(undefined)
  const [selectUnStakingItem, setSelectUnStakingItem] = useState(undefined)
  const [selectViewScheduleItem, setSelectViewScheduleItem] = useState(undefined)

  const [isLoading, setIsLoading] = useState(false)
  const [claimDialog, setClaimDialog] = useState(false)
  const [depositDialog, setDepositDialog] = useState(false)
  const [withdrawDialog, setWithdrawDialog] = useState(false)
  const [viewScheduleDialog, setViewScheduleDialog] = useState(false)

  const router = useRouter()

  const handelStaking = (stakingId) => {
    const selectProgram = stakingPrograms.find((f) => f.externalId === stakingId)
    const selectMyDeposit = myStakingPrograms
      ? myStakingPrograms.find((f) => f.earlyStakingProgramExternalId === stakingId)
      : undefined
    setSelectStakingItem({ selectProgram, selectMyDeposit })
    setDepositDialog(true)
  }

  const handelUnStaking = (stakingId) => {
    const selectProgram = stakingPrograms.find((f) => f.externalId === stakingId)
    const selectMyDeposit = myStakingPrograms
      ? myStakingPrograms.find((f) => f.earlyStakingProgramExternalId === stakingId)
      : undefined
    setSelectUnStakingItem({ selectProgram, selectMyDeposit })
    setWithdrawDialog(true)
  }

  const handelClaim = (stakingId) => {
    const selectProgram = stakingPrograms.find((f) => f.externalId === stakingId)
    const selectMyDeposit = myStakingPrograms
      ? myStakingPrograms.find((f) => f.earlyStakingProgramExternalId === stakingId)
      : undefined
    setSelectClaimItem({ selectProgram, selectMyDeposit })
    setClaimDialog(true)
  }

  const handelViewSchedule = (stakingId) => {
    const selectProgram = stakingPrograms.find((f) => f.externalId === stakingId)
    setSelectViewScheduleItem(selectProgram)
    setViewScheduleDialog(true)
  }

  async function requestClaim(programId) {
    setIsLoading(true)
    notify({
      message: `Request Claim...`,
      type: 'info',
    })
    const response = await stakingProgramClaim(accessToken, programId, false)
    if (response && response.status === 200 && response.data) {
      notify({
        message: `Success Claim!`,
        type: 'success',
      })

      setIsLoading(false)
      setClaimDialog(false)
      setSelectClaimItem(undefined)
      refresh()
    } else if (response.status === 401 || response.status === 403) {
      notify({
        message: 'Please sign in again.',
        type: 'error',
      })
      router.push('/login?ref=/staking')
    } else {
      setIsLoading(false)
      notify({
        message: response && response.message ? response.message : `Fail Claim`,
        type: 'error',
      })
    }
  }

  async function requestDeposit(programId, amount) {
    setIsLoading(true)
    notify({
      message: `Request Deposit...`,
      type: 'info',
    })
    const response = await stakingProgramDeposit(
      accessToken,
      programId,
      {
        amount: amount,
      },
      false,
    )
    console.log(response)
    if (response && response.status === 200 && response.data) {
      notify({
        message: `Success Deposit!`,
        type: 'success',
      })

      setIsLoading(false)
      setDepositDialog(false)
      setSelectStakingItem(undefined)
      refresh()
    } else if (response.status === 401 || response.status === 403) {
      notify({
        message: 'Please sign in again.',
        type: 'error',
      })
      router.push('/login?ref=/staking')
    } else {
      setIsLoading(false)
      notify({
        message: response && response.message ? response.message : 'Fail Deposit!',
        type: 'error',
      })
    }
  }

  async function requestWithdraw(programId, amount) {
    setIsLoading(true)
    notify({
      message: `Request Withdraw...`,
      type: 'info',
    })
    const response = await stakingProgramWithdraw(
      accessToken,
      programId,
      {
        amount: amount,
      },
      false,
    )
    if (response && response.status === 200 && response.data) {
      notify({
        message: `Success Withdraw!`,
        type: 'success',
      })

      setIsLoading(false)
      setWithdrawDialog(false)
      setSelectUnStakingItem(undefined)
      refresh()
    } else if (response.status === 401 || response.status === 403) {
      notify({
        message: 'Please sign in again.',
        type: 'error',
      })
      router.push('/login?ref=/staking')
    } else {
      setIsLoading(false)
      notify({
        message: response && response.message ? response.message : `Fail Withdraw`,
        type: 'error',
      })
    }
  }

  return (
    <>
      {claimDialog && selectClaimItem && (
        <StakingClaimDialog
          program={selectClaimItem.selectProgram}
          myDeposit={selectClaimItem.selectMyDeposit}
          isLoading={isLoading}
          requestClaim={requestClaim}
          onClose={() => {
            setClaimDialog(false)
          }}
        />
      )}
      {depositDialog && selectStakingItem && (
        <StakingDepositDialog
          program={selectStakingItem.selectProgram}
          myDeposit={selectStakingItem.selectMyDeposit}
          isLoading={isLoading}
          accessToken={accessToken}
          requestDeposit={requestDeposit}
          onClose={() => {
            setDepositDialog(false)
          }}
        />
      )}
      {withdrawDialog && selectUnStakingItem && (
        <StakingWithdrawDialog
          program={selectUnStakingItem.selectProgram}
          myDeposit={selectUnStakingItem.selectMyDeposit}
          isLoading={isLoading}
          requestWithdraw={requestWithdraw}
          onClose={() => {
            setWithdrawDialog(false)
          }}
        />
      )}
      {viewScheduleDialog && selectViewScheduleItem && (
        <StakingScheduleDialog
          program={selectViewScheduleItem}
          onClose={() => {
            setViewScheduleDialog(!viewScheduleDialog)
          }}
        />
      )}
      <div className="rounded-2lg border border-jacarta-100 bg-white text-sm dark:border-jacarta-600 dark:bg-jacarta-700 dark:text-white">
        <div className="flex flex-col gap-4 rounded-t-2lg border-b border-jacarta-100 bg-jacarta-50 p-4 dark:border-jacarta-600 dark:bg-jacarta-800 sm:gap-6 lg:flex-row lg:items-center">
          <div className="flex flex-1 flex-col justify-between gap-4 md:flex-row md:items-center md:gap-10">
            <div className="flex flex-shrink-0 flex-col space-y-1">
              <div className="flex flex-shrink-0 items-center space-x-1">
                {type === 'LIVE' ? (
                  <span className="mr-1 inline-block animate-heartBeat bg-contain bg-center text-xl">⚡</span>
                ) : (
                  <span className="mr-1 inline-block bg-contain bg-center text-xl">🍂</span>
                )}

                <div className="flex flex-shrink-0 flex-col">
                  <div className="text-base font-medium uppercase text-jacarta-500 dark:text-jacarta-300 md:whitespace-nowrap">
                    {type === 'LIVE' && 'Live Staking'}
                    {type === 'END' && 'Ended Staking'}
                    {type === 'MY' && 'My Staking'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {stakingPrograms && stakingPrograms.length > 0 ? (
          <StakingTable
            stakingPrograms={stakingPrograms}
            myStakingPrograms={myStakingPrograms}
            isLogin={isLogin}
            handelClaim={handelClaim}
            handelStaking={handelStaking}
            handelUnStaking={handelUnStaking}
            handelViewSchedule={handelViewSchedule}
          />
        ) : (
          <div className="flex items-center justify-center h-32">There is no information to show yet 🥺</div>
        )}
      </div>
    </>
  )
}

export default StakingContent
